import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import ClientLayout from '../../layouts/ClientLayout';

const Boutiques = () => {
  const [viewMode, setViewMode] = useState('grid'); // 'grid' ou 'list'

  // Données des boutiques
  const boutiques = [
    {
      id: 1,
      name: "Bolobaba SARL",
      address: "1986 Spinnaker Lane, Illinois, Freeport, 61032, USA",
      logo: "/images/fournisseurs/img1.png",
      logoBg: "bg-green-500"
    },
    {
      id: 2,
      name: "Clothing Shop",
      address: "4885 Spring Street, Illinois, Freeport, 61032, USA",
      logo: "/images/fournisseurs/img2.png",
      logoBg: "bg-red-500"
    },
    {
      id: 3,
      name: "Books Shop",
      address: "1234 Library Street, New York, NY, 10001, USA",
      logo: "/images/fournisseurs/img3.png",
      logoBg: "bg-blue-500"
    },
    {
      id: 4,
      name: "Furniture Shop",
      address: "5678 Wood Avenue, California, LA, 90210, USA",
      logo: "/images/fournisseurs/img4.png",
      logoBg: "bg-purple-500"
    },
    {
      id: 5,
      name: "Grocery Shop",
      address: "9012 Market Road, Texas, Houston, 77001, USA",
      logo: "/images/fournisseurs/img5.png",
      logoBg: "bg-yellow-500"
    },
    {
      id: 6,
      name: "Electronics Shop",
      address: "3456 Tech Boulevard, Washington, Seattle, 98101, USA",
      logo: "/images/fournisseurs/img6.png",
      logoBg: "bg-indigo-500"
    },
    {
      id: 7,
      name: "Sports Shop",
      address: "7890 Fitness Street, Florida, Miami, 33101, USA",
      logo: "/images/fournisseurs/img7.png",
      logoBg: "bg-green-600"
    },
    {
      id: 8,
      name: "Beauty Shop",
      address: "2345 Glamour Lane, Nevada, Las Vegas, 89101, USA",
      logo: "/images/fournisseurs/img8.png",
      logoBg: "bg-pink-500"
    },
    {
      id: 9,
      name: "Home Decor Shop",
      address: "6789 Design Drive, Oregon, Portland, 97201, USA",
      logo: "/images/fournisseurs/img9.png",
      logoBg: "bg-teal-500"
    },
    {
      id: 10,
      name: "Pet Shop",
      address: "4567 Animal Avenue, Colorado, Denver, 80201, USA",
      logo: "/images/fournisseurs/img1.png",
      logoBg: "bg-orange-light"
    },
    {
      id: 11,
      name: "Jewelry Shop",
      address: "8901 Sparkle Street, Arizona, Phoenix, 85001, USA",
      logo: "/images/fournisseurs/img2.png",
      logoBg: "bg-amber-500"
    }
  ];

  return (
    <ClientLayout>
      <div className="flex-1 md:mx-8 lg:mx-16 mx-auto py-8">
        <div className="mb-4">
          <nav className="text-sm text-gray-600">
            <Link to="/" className="hover:text-gray-900">Accueil</Link>
            <span className="mx-2">&gt;</span>
            <span className="text-gray-900">Boutiques</span>
          </nav>
        </div>

        {/* Main Content */}
        <div className="">
          {/* Header with Title and View Toggle */}
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-2">
            <h1 className="text-lg font-bold text-gray-900 mb-4 sm:mb-0">
              Liste des Fournisseurs/Boutiques sur Kilimmanjaro
            </h1>

            {/* View Toggle Buttons */}
            <div className="flex items-center space-x-2 bg-white rounded-lg border border-gray-200 p-1">
              <button
                onClick={() => setViewMode('grid')}
                className={`p-2 rounded-md transition-colors ${viewMode === 'grid'
                    ? 'bg-orange-100 text-orange-hover'
                    : 'text-gray-500 hover:text-gray-700 hover:bg-gray-100'
                  }`}
                title="Vue grille"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M5 3a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2V5a2 2 0 00-2-2H5zM5 11a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2v-2a2 2 0 00-2-2H5zM11 5a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V5zM11 13a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" />
                </svg>
              </button>

              <button
                onClick={() => setViewMode('list')}
                className={`p-2 rounded-md transition-colors ${viewMode === 'list'
                    ? 'bg-orange-100 text-orange-hover'
                    : 'text-gray-500 hover:text-gray-700 hover:bg-gray-100'
                  }`}
                title="Vue liste"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M3 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clipRule="evenodd" />
                </svg>
              </button>
            </div>
          </div>

          {/* Boutiques Grid/List */}
          {viewMode === 'grid' ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              {boutiques.map((boutique) => (
                <div
                  key={boutique.id}
                  className="hover:cursor-pointer bg-white rounded-lg shadow-sm border border-gray-200 p-4 hover:shadow-md transition-shadow duration-200"
                >
                  <div className="flex items-start space-x-4">
                    {/* Logo circulaire */}
                    <img
                      src={boutique.logo}
                      alt={`Logo ${boutique.name}`}
                      className="w-12 h-12 object-contain"
                    />

                    {/* Informations de la boutique */}
                    <div className="flex-1 min-w-0">
                      <h3 className="text-base font-bold text-gray-900">
                        {boutique.name}
                      </h3>
                      <div className="flex items-start space-x-2">
                        <svg className="flex-shrink-0 w-4 h-4 text-gray-400 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                        </svg>
                        <p className="text-xs text-gray-600 leading-relaxed">
                          {boutique.address}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="space-y-4">
              {boutiques.map((boutique) => (
                <div
                  key={boutique.id}
                  className="bg-white hover:cursor-pointer rounded-lg shadow-sm border border-gray-200 p-6 hover:shadow-md transition-shadow duration-200"
                >
                  <div className="flex items-center space-x-4">
                    <img
                      src={boutique.logo}
                      alt={`Logo ${boutique.name}`}
                      className="w-12 h-12 object-contain"
                    />

                    {/* Informations de la boutique */}
                    <div className="flex-1 min-w-0">
                      <h3 className="text-base font-bold text-gray-900 mb-1">
                        {boutique.name}
                      </h3>
                      <div className="flex items-start space-x-2">
                        <svg className="flex-shrink-0 w-4 h-4 text-gray-400 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                        </svg>
                        <p className="text-sm text-gray-600 leading-relaxed">
                          {boutique.address}
                        </p>
                      </div>
                    </div>

                    {/* Bouton d'action */}
                    <div className="flex-shrink-0">
                      <button className="bg-orange-hover text-white py-2 px-4 rounded-lg text-sm font-medium hover:bg-orange-700 transition-colors duration-200">
                        Voir la boutique
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </ClientLayout>
  );
};

export default Boutiques;
